export var polarisAppIds = ['wx53aed20bd888a9a7', 'wx8734de71e9438268' // 线上小程序appId 北极星伴读
];